/*eslint no-console: "off" */

const infoPrefix =  'INFO ';
const warnPrefix =  'WARN ';
const errorPrefix = 'ERROR';

const currentLog = window.console;

/**
 * Provides more advanced logging for the framework and applications.
 */
export default class Log {

    /**
     * Formats a log message
     * @param {string} level The log level (info, warn, error)
     * @param {string} name The name of the application using the log.
     * @param {string} message The message to output
     * @returns {string} The formated log message.
     */
    static formatMessage(level, name, message) {
        return `[${level}] ${name} ➜ ${message}`;
    }

    /**
     * Creates a new instance of Log
     * @param {string} sourceName The name of the library or framework using the log.
     */
    constructor(sourceName) {
        this.sourceName = sourceName;
        this.logInfo = false;
        this.logWarn = true;
        this.logError = true;
    }

    /**
     * Logs an informational message.
     * @param {string} message The info message to output to the log.
     * @returns {void}
     */
    info(message) {
        if (!this.logInfo) {
            return;
        }

        currentLog.log(Log.formatMessage(infoPrefix, this.sourceName, message));
    }

    /**
     * Logs a warning message
     * @param {string} message The warning message to output to the log.
     * @returns {void}
     */
    warn(message) {
        if (!this.logWarn) {
            return;
        }

        currentLog.warn(Log.formatMessage(warnPrefix, this.sourceName, message));
    }

    /**
     * Logs an error message.
     * @param {string} message The error message to output to the log.
     * @returns {void}
     */
    error(message) {
        if (!this.logError) {
            return;
        }

        currentLog.error(Log.formatMessage(errorPrefix, this.sourceName, message));
    }
}


// WEBPACK FOOTER //
// ./source/framework/core/Log.js